<script>
import { ref } from 'vue'

import { TIME_VARIABLES } from './_search-criterion-predicate-config.js'

export default {
  name: 'DateTimeWithVariablesInput',
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String,
      // required: true,
    },
    modelValue: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    skipDirtyCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      datetimeChosenVariables: ref({}),
      showPicker: ref(
        props.modelValue?.length && !Object.keys(TIME_VARIABLES).includes(props.modelValue),
      ),
    }
  },
  computed: {
    chosenVariable: {
      get() {
        if (Object.keys(TIME_VARIABLES).includes(this.modelValue)) {
          return this.modelValue
        } else if (this.modelValue?.length || this.showPicker) {
          return 'specific'
        } else {
          return null
        }
      },
      set(newVal) {
        if (newVal == 'specific') {
          this.showPicker = true
          this.$emit('update:modelValue', null)
        } else {
          if (!newVal?.length) {
            this.showPicker = false
          }
          this.$emit('update:modelValue', newVal)
        }
      },
    },
    chosenTimestamp: {
      get() {
        if (Object.keys(TIME_VARIABLES).includes(this.modelValue) || !this.showPicker) {
          return null
        } else {
          return this.modelValue
        }
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal)
      },
    },
    variablesSelectorOptions() {
      const result = Object.keys(TIME_VARIABLES).map(k => ({ value: k, label: TIME_VARIABLES[k] }))
      result.push({ value: 'specific', label: 'Specific value' })
      return result
    },
  },
  methods: {
    onSelectSpecificValue() {
      this.chosenVariable = 'specific'
      this.$nextTick(() => {
        this.$refs.datetimePicker?.focus?.()
      })
    },
  },
}
</script>

<template lang="pug">
.datetime-with-variables-input
  ea-select.select-nowrap(
    :label="label"
    :name="`${name}.variablesSelector`"
    :options="variablesSelectorOptions"
    :reduce="item => item.value"
    :skipDirtyCheck="skipDirtyCheck"
    v-model="chosenVariable"
    input-size="sm"
    select-label="label"
  )
    template(v-if="chosenVariable != 'specific'" #input-prepend)
      a.d-flex.align-items-center.justify-content-center.p-2(v-tooltip="'Specific value'")
        i.fa.fa-calendar.text-primary.cursor-pointer(@click="onSelectSpecificValue")

  separated-datetimepicker(
    ref="datetimePicker"
    v-if="chosenVariable == 'specific'"
    :name="name"
    :skipDirtyCheck="skipDirtyCheck"
    :timeZone="$store.state.session.timeZone"
    v-model="chosenTimestamp"
    disableLabel
    input-size="sm"
  )
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.datetime-with-variables-input {
  display: grid;
  gap: 8px;

  & :deep(.clear-datetime-button) {
    width: 32px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid map.get(themeVariables.$colors, outline);
    border-left: none;
    border-top-right-radius: themeVariables.$borderRadius;
    border-bottom-right-radius: themeVariables.$borderRadius;

    &:hover {
      background: map.get(themeVariables.$colors, containerHighest);
    }
  }
}

.datetime-picker {
  //.clear-datetime-button {
  //  height: 33px;
  //  border-top-right-radius: 0;
  //  border-top: none !important;
  //}

  //:deep(.input-group .form-control),
  //:deep(.form-group .form-control) {
  //  border-top: 0 !important;
  //}
  //
  //:deep(.form-group .form-control) {
  //  border-top-left-radius: 0;
  //}
  //:deep(.input-group .form-control) {
  //  border-right: none;
  //}
}
</style>
